import * as React from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components';

const spinner = require('./resources/spinner.json');

const SpinnerParentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background: none;
`;

const SpinnerContainer = styled.div`
  margin: auto;
`;

const spinnerOptions = {
  loop: true,
  autoplay: true,
  animationData: spinner,
};

export class Spinner extends React.Component<any> {
  render() {
    return (
      <SpinnerParentContainer>
        <SpinnerContainer>
          <Lottie options={spinnerOptions} />
        </SpinnerContainer>
      </SpinnerParentContainer>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/signup/components/Spinner.tsx